export { default } from './ProgramDetailSeparateSection';
